import useProfileCommonStore from './use-profile-common-store';

import { useProfileDisclosures, useQuote } from '../../hooks/api';
import useParticipantHoldingsStore from './use-participant-holdings-store';

const useFixedAnnuityOtherStore = () => {
  const { apiConfigBase, commonState } = useProfileCommonStore();

  return {
    ...commonState,
    disclosureList: useProfileDisclosures({ ...apiConfigBase, forPrint: true }),
    participantHoldings: useParticipantHoldingsStore({ apiConfigBase, commonState }),
    quote: useQuote(apiConfigBase)
  };
};

export default useFixedAnnuityOtherStore;
